const HomeAlphaWidget = () => import(/* webpackChunkName: "FactCheckHomeAlphaWidget" */ "./HomeAlphaWidget.vue");
const HomeBetaWidget = () => import(/* webpackChunkName: "FactCheckHomeBetaWidget" */ "./HomeBetaWidget.vue");

function init_fc_alpha_table(selector){

    // Start App
    new Vue({
        el: selector,
        render: h => h(HomeAlphaWidget),
    });
}

function init_fc_beta_widget(selector){

    // Start App
    new Vue({
        el: selector,
        render: h => h(HomeBetaWidget),
    });
}


function lazy_init_fact_check_app(selector, callback){

    var lazy_init_callback = function(){
        if( window.$(selector) && window.$(selector).inViewport(50) ){
            callback(selector);
            $(window).off("scroll rezise", lazy_init_callback);
        }
    }

    $(window).on('scroll rezise', lazy_init_callback).scroll().resize();
}

function init_widgets(){
    lazy_init_fact_check_app('#fcr_alpha_widget', init_fc_alpha_table);
    lazy_init_fact_check_app('#fcr_beta_widget', init_fc_beta_widget);
}

export default init_widgets;